import { render, staticRenderFns } from "./subjectAdmin.vue?vue&type=template&id=06ee9128&scoped=true&"
import script from "./subjectAdmin.vue?vue&type=script&lang=js&"
export * from "./subjectAdmin.vue?vue&type=script&lang=js&"
import style0 from "./subjectAdmin.vue?vue&type=style&index=0&id=06ee9128&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee9128",
  null
  
)

export default component.exports